import { LegendItem, LegendIcon } from './ColorLegend.styles'
import BlueSquareIcon from '@assets/icons/square-blue-solid.svg'
import GreenSquareIcon from '@assets/icons/square-green-solid.svg'
import OrangeSquareIcon from '@assets/icons/square-orange-solid.svg'
import YellowSquareIcon from '@assets/icons/square-yellow-solid.svg'
import { Typography, Stack } from '@mui/material'

const legendItems = [
  { icon: OrangeSquareIcon, label: 'Proposição monitorada em pauta' },
  { icon: BlueSquareIcon, label: 'Eventos salvos em minha agenda' },
  { icon: GreenSquareIcon, label: 'Outros eventos' },
  { icon: YellowSquareIcon, label: 'Palavras-chave salva' },
]

export function ColorLegend() {
  return (
    <Stack spacing={1}>
      <Typography
        sx={{
          fontSize: '14px',
          color: '$color-text-primary',
        }}
        data-testid="title"
        variant="$font-body-5"
      >
        Legendas
      </Typography>

      {legendItems.map((item) => (
        <LegendItem key={item.label}>
          <LegendIcon src={item.icon} alt={item.label} />
          <Typography
            sx={{
              fontSize: '12px',
              color: '$color-text-secondary',
            }}
          >
            {item.label}
          </Typography>
        </LegendItem>
      ))}
    </Stack>
  )
}
